import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import SvgIcon from 'li-components/lib/SvgIcon'
import vars from 'li-components/lib/styles'

import { isEmpty } from '../../util'
import Search from './Search'
import PlatformNav from './PlatformNav'
import renderWelcomeNav from './renderWelcomeNav'

const Container = styled.nav`
  ${p =>
    p.loggedOut &&
    `
    display: flex;
    justify-content: flex-end;
  `};
`

const List = styled.ul`
  display: flex;
  height: 100%;
  padding: 0;
  margin: 0;
  list-style: none;

  @media (max-width: ${vars.screenMd}) {
    display: none;
  }

  > li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    padding: 0 10px;
    font-weight: 700;
    cursor: pointer;

    &:hover:not([class*='search'], [class*='userMenu']) {
      background: ${vars.grayLighter};
    }

    &.search {
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex: 4;
      padding: 0 15px;
    }

    > a {
      display: block;
    }
  }

  .registerLink {
    color: ${vars.brandPrimary};
  }
`

const whenImpersonating = (thenColor, elseColor) => p =>
  p.impersonating ? thenColor : elseColor

const User = styled.li`
  display: flex;
  flex-direction: row !important;
  align-items: center;
  margin-left: auto;
  background-color: ${whenImpersonating(vars.labelInsightPurple, 'white')};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${whenImpersonating(
      vars.labelInsightPurple,
      vars.grayLighter
    )};
    transition: color 0.2s;

    > .SvgIcon svg {
      fill: ${whenImpersonating('white', vars.gray)};
    }

    > main {
      color: ${whenImpersonating('white', vars.gray)};
    }
  }

  > main {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: ${whenImpersonating('white', vars.grayLight)};

    > span {
      font-weight: 600;
    }
  }
`

const UserTabIcon = styled(SvgIcon)`
  margin-left: 0.5rem;

  svg {
    width: 1em;
    height: 1em;
    fill: ${whenImpersonating('white', vars.grayLight)}};
    transition: color 0.2s;
  }
`

const Avatar = UserTabIcon.extend.attrs({ name: 'user-1' })`
  margin-right: 0.75rem;
`

const EmailText = styled.span`
  display: inline-block;
  width: 100%;
  max-width: 256px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export default class Nav extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    impersonatedUser: PropTypes.object.isRequired,
    appShellUi: PropTypes.object.isRequired,
    onUserMenuClick: PropTypes.func.isRequired,
  }

  static contextTypes = {
    customNav: PropTypes.func,
    customSearch: PropTypes.func,
    appId: PropTypes.string,
    getEffectiveUser: PropTypes.func.isRequired,
  }

  shouldRenderLoggedIn() {
    const { user } = this.props
    return !isEmpty(user) && user.verified
  }

  render() {
    const { impersonatedUser, appShellUi, onUserMenuClick } = this.props
    const { customNav, appId } = this.context
    const loggedIn = this.shouldRenderLoggedIn()
    const effectiveUser = this.context.getEffectiveUser()

    return (
      <Container loggedOut={!loggedIn}>
        {loggedIn ? (
          <List>
            <PlatformNav customNav={customNav} appId={appId} />
            {appShellUi.showSearch && (
              <li className="search">
                {this.context.customSearch ? (
                  this.context.customSearch()
                ) : (
                  <Search />
                )}
              </li>
            )}
            <User
              impersonating={impersonatedUser.email}
              onClick={onUserMenuClick}
            >
              <Avatar />
              <main>
                <EmailText>{effectiveUser.email}</EmailText>
                {(effectiveUser.profiles || []).length > 1 && (
                  <span>{effectiveUser.organizationName}</span>
                )}
              </main>
            </User>
          </List>
        ) : (
          <List>{renderWelcomeNav()}</List>
        )}
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/Nav.js